import * as React from "react";
import Breadcrumbs from "./Breadcrumbs";
import history from "src/plugins/history";

interface Props {
  title: string;
  back?: boolean;
  projectName?: string;
}
export class HeaderPage extends React.Component<Props> {
  getPaths = pathname => {
    const paths = ["/"];
    if (pathname === "/") {
      return paths;
    }
    pathname.split("/").reduce((prev, curr) => {
      const currPath = `${prev}/${curr}`;
      paths.push(currPath);
      return currPath;
    });
    return paths;
  };
  onBack = () => {
    history.goBack();
    /* if(!this.props.back){
      return;
    }
    const location = this.getPaths(history.location.pathname);
    /* for retrieve parent url, transform string in array
     * And remove the last 2 index correspond a current url
     */
    /*
    const newLocation = location.splice(0, location.length - 2);
    history.push(newLocation[newLocation.length - 1]);
    */
  };
  render() {
    return (
      <div className="header-page" onClick={this.onBack}>
        <div>
          <button
            className={!this.props.back ? "invisible" : ""}
          >
            <img
              className="mr-1"
              src="assets/svgs/right-chevron.svg"
              width="10px"
            />
          </button>
        </div>
        <div className="header-breadcrumb">
          <h1>{this.props.title}</h1>
          <Breadcrumbs />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HeaderPage.tsx